const goodTransformer = good => good.id;

export default goodTransformer;
